const date = new Date();
const year = date.getFullYear();
const month = date.getMonth();

export const CURRENT_MONTH: number = month + 1;
export const CURRENT_YEAR: number = year;
export const POPUP = 'popup';
export const ACTIVE = 'calendar-month__day calendar-month__day_active';



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/calendar/consts.ts